'use strict';

var cache = {};

function renderStatusMsg(data, $errorContainer) {
    if (!data && !$errorContainer) {
        return;
    }

    $errorContainer.removeClass('bbw-msg-error').removeClass('bbw-msg-success');
    $errorContainer.html('');

    if (data.error) {
        $errorContainer.addClass('bbw-msg-error');
    } else {
        $errorContainer.addClass('bbw-msg-success');
    }

    $errorContainer.html(data.msg);
}

module.exports = {
    emailSubscribeCache: function () {
        cache.$emailSubscribeForm = $('.js-email-subscribe-form');
        cache.$emailSunscribeStatus = $('.js-email-subscribe-status');
    },
    emailSubscribe: function () {
        cache.$emailSubscribeForm.submit(function (e) {
            e.preventDefault();
            var $form = $(this);
            var url = $form.attr('action');

            $form.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                data: $form.serialize()
            }).done(function (data) {
                renderStatusMsg(data, cache.$emailSunscribeStatus);

                if (!data.error) {
                    $('body').trigger('emailSubscribe:done');
                }
            }).always(function () {
                $form.spinner().stop();
            });
        });
    }
};

